// extracted by mini-css-extract-plugin
var _1 = "DepositQrCodeStyle-module__address___sIwRs";
var _2 = "DepositQrCodeStyle-module__address-holder___GaEe4";
var _3 = "DepositQrCodeStyle-module__address-holder___GaEe4";
var _4 = "DepositQrCodeStyle-module__qr-img___Akm9y";
var _5 = "DepositQrCodeStyle-module__qr-img___Akm9y";
export { _1 as "address", _2 as "address-holder", _3 as "addressHolder", _4 as "qr-img", _5 as "qrImg" }
